import React from "react";

function MetricCard({
  metric,
  title,
  description,
  badge,
  shadowColor = "#ccd5ae", // Default: Moss
  hoverShadowColor = "#d4a373", // Default saat Hover: Bronze
  className = "",
}) {
  return (
    <div
      style={{
        "--card-shadow": shadowColor,
        "--card-hover-shadow": hoverShadowColor,
      }}
      className={`border-2 border-slate-900 bg-white rounded-2xl p-6 flex flex-col justify-between transition-all duration-300 hover:-translate-y-1 shadow-[6px_6px_0px_0px_var(--card-shadow)] hover:shadow-[10px_10px_0px_0px_var(--card-hover-shadow)] ${className}`}
    >
      <div>
        {badge && (
          <span className="inline-block text-[9px] font-mono font-bold uppercase tracking-widest text-gsf-bronze bg-gsf-sand/40 border border-gsf-bronze/20 px-2 py-0.5 rounded mb-4">
            {badge}
          </span>
        )}
        <h3 className="text-4xl sm:text-5xl font-black text-slate-900 tracking-tight leading-none">
          {metric}
        </h3>
        <p className="text-sm font-bold text-slate-800 mt-2 uppercase tracking-wide">
          {title}
        </p>
      </div>

      {description && (
        <p className="text-xs sm:text-sm text-slate-500 font-medium mt-4 leading-relaxed border-t border-slate-100 pt-3">
          {description}
        </p>
      )}
    </div>
  );
}

export default MetricCard;
